import React from "react";
import { BuildDocument, RegisterFont } from "./InvoiceBill";
import { GetRadConnHeader, keywordColor } from "./PayDFBill";
import { Image, Text, View } from "@react-pdf/renderer";
import { BillStylesA4 as styles } from "./BillStyle";
import { GetThaiFormatDate, toDecimal } from "../../core/Helper";
import { getDecimalString } from "../../core/Helper2";

export default async function BillingNoteBuilder(props) {
  const { data, pdf, setPdf, items } = props;
  RegisterFont();

  setPdf(
    <BuildDocument
      {...{
        docHeader: await GetBillingNoteHeader({ data, items }),
        customer: await GetBillingNoteDocuInfo({ data }),
        items: await GetBillNoteItems({
          data,
          items,
        }),
        footer: await GetBillNoteSummaryItems({
          data,
          items,
        }),
        footer2: await GetBillNoteFooter({ data }),
        pageStyles: { paddingLeft: "30px", paddingRight: "20px" },
      }}
    />
  );
}

export const GetBillingNoteHeader = async ({ data }) => {
  const { Branch, DocuType } = data?.DocuBranch?.BranchDocu;
  const getTextAddr = (text) => (
    <Text
      style={{
        ...styles.textSmall,
        ...{
          textAlign: "center",
        },
      }}
    >
      {text}
    </Text>
  );
  return (
    <View style={{ paddingTop: "10px", paddingBottom: "10px" }}>
      <View
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <View
          style={{
            ...{
              marginTop: "10px",
              overflow: "hidden",
            },
          }}
        >
          <Image
            style={{
              ...styles.logo,
              ...{
                width: "60px",
                height: "40px",
                marginTop: "-8px",
              },
            }}
            src={"/logos/logo_comp_" + Branch.Company?.CompId + ".png"}
            // src={"/logos/logo_comp_radconn.png"}
          />
        </View>

        <View
          style={{ display: "flex", justifyContent: "center", width: "100%" }}
        >
          <Text
            style={{
              ...styles.textVeryLarge,
              ...{
                fontSize: "16px",
                color: keywordColor,
                fontFamily: "Browallia",
                textAlign: "center",
              },
            }}
          >
            {Branch.Company?.CompNameTh}
          </Text>
          {getTextAddr(
            `${Branch.Company?.CompAddrTh} ${Branch.Company?.CompAddrTh2}`
          )}
          {/* {getTextAddr(Branch.Company?.CompAddrTh2)} */}
          {getTextAddr(`เลขประจำตัวผู้เสียภาษี ${Branch.Company?.Taxid}`)}
          {getTextAddr(`โทร.${Branch.Company?.Phone}`)}
        </View>
      </View>
    </View>
  );
};

export const GetBillingNoteDocuInfo = async ({ data }) => {
  const { DocuType } = data?.DocuBranch?.BranchDocu;
  const { Customer, DocuNo, DocuDate } = data;
  const getTextLeft = (text, style2) => (
    <Text
      style={{
        ...styles.textLabel,
        ...{ textAlign: "left", padding: "0px" },
        ...style2,
      }}
    >
      {text}
    </Text>
  );
  const docuNameStyle = {
    ...styles.textVeryLarge,
    color: keywordColor,
    paddingVertical: "5px",
  };

  return (
    <View style={{ paddingBottom: "10px" }}>
      <View
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        <Text style={docuNameStyle}>{DocuType?.DocuTypeText} </Text>
      </View>
      <View
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          paddingVertical: "10px",
        }}
      >
        <Text style={{ ...styles.textSmall }}>{`วันที่ ${GetThaiFormatDate(
          DocuDate
        )}`}</Text>
        <Text style={{ ...styles.textSmall }}>{`เลขที่ ${DocuNo}`}</Text>
      </View>
      {getTextLeft(
        `เรื่อง  ส่งเอกสารเพื่อแจ้งรายละเอียดคนไข้ส่งตรวจเอกซเรย์คอมพิวเตอร์`
      )}
      {getTextLeft(`เรียน  ผู้อำนวยการ ${Customer?.CustName}`)}
      {getTextLeft(
        `รายละเอียดการให้บริการ CT-Scan กรณีผู้ป่วยของ ${Customer?.CustName} `,
        { paddingLeft: "25px" }
      )}
      {getTextLeft(`ประจำเดือน กุมภาพันธ์ 2568 `, { paddingLeft: "25px" })}
    </View>
  );
};

export const GetBillNoteItems = async ({ data, items }) => {
  return (
    <View>
      <View
        fixed
        style={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
          // border: "1px solid black",
        }}
      >
        <Text
          style={{ ...styles.textSmall, textAlign: "right" }}
          render={({ pageNumber, totalPages }) =>
            `หน้า : ${pageNumber}/${totalPages}`
          }
        ></Text>
      </View>
      {await GetBillNoteRowHeader({ data })}
      {await GetBillNoteRowsData({ data, items })}
    </View>
  );
};

export const GetBillNoteRowHeader = async (props) => (
  <View
    style={{
      ...styles.itemRow,
      ...{
        justifyContent: "center",
        alignItems: "center",
        paddingTop: "10px",
      },
    }}
    fixed
  >
    {getHeader("ลำดับ", "30px")}
    {getHeader("วันเดือนปี", "60px")}
    {getHeader("HN", "60px")}
    {getHeader("ชื่อคนไข้", "120px")}
    {getHeader("รายการตรวจ", "0", { display: "flex", flex: "1" })}
    {getHeader("รหัสกรม", "40px")}
    {getHeader("เรียกเก็บ", "40px", { textAlign: "right" })}
  </View>
);

export const GetBillNoteRowsData = async (props) => {
  const { data, items } = props;
  return (
    <View>
      {items?.map((item, ind) => {
        return (
          <View
            style={{
              ...styles.itemRow,
              ...{ justifyContent: "center", alignItems: "start" },
            }}
          >
            {getRow(`${ind + 1}.`, "30px")}
            {getRow(`${GetThaiFormatDate(item?.request_date)}`, "60px")}
            {getRow(`${item?.hn}`, "60px")}
            {getRow(`${item?.patients_name}`, "120px")}
            {getRow(`${item?.item_name}`, "0", { display: "flex", flex: "1" })}
            {getRow(`${item?.item_code}`, "40px", { textAlign: "center" })}
            {getRow(`${getDecimalString(item?.price)}`, "40px", {
              textAlign: "right",
            })}
          </View>
        );
      })}
    </View>
  );
};

export const GetBillNoteSummaryItems = async (props) => {
  const { items, data } = props;
  let sum = 0;
  items?.map((item, i) => (sum = sum + Number(item?.price)));

  return (
    <View>
      <View style={styles.itemRow}>
        {getRow(
          `รวมจำนวนรายการทั้งสิ้น  ${getDecimalString(items.length, 0)} รายการ`,
          "264px",
          { textAlign: "center", paddingVertical: "5px" }
        )}

        {getRow(`รวม`, "0", {
          display: "flex",
          flex: "1",
          textAlign: "right",
          paddingVertical: "5px",
          paddingRight: "10px",
        })}

        {getRow(`${toDecimal(sum, 2)}`, "78px", {
          textAlign: "right",
          paddingVertical: "5px",
        })}
      </View>
    </View>
  );
};

export const GetBillNoteFooter = async (props) => {
  return (
    <View style={{ display: "flex", width: "100%", marginTop: "20px" }}>
      {getRow(`ภายใน 30 วันนับจากวางบิล`, "100%", {
        textAlign: "center",
        paddingTop: "5px",
        marginBottom: "10px",
        border: "none",
      })}

      <View
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "end",
          alignItems: "end",
        }}
      >
        <View
          style={{
            display: "flex",
            flex: "1",
            border: "1px solid #c0bcbc",
            justifyContent: "center",
            alignItems: "center",
            paddingVertical: "10px",
          }}
        >
          {getRow(`จึงเรียนมาเพื่อโปรดพิจารณา`, "100%", {
            textAlign: "center",
            paddingVertical: "5px",

            border: "none",
          })}
          {getRow(`ขอแสดงความนับถือ`, "100%", {
            paddingVertical: "5px",
            paddingTop: "0px",
            border: "none",
            textAlign: "center",
          })}
          {getRow(`......................................`, "100%", {
            paddingVertical: "5px",
            marginTop: "20px",
            border: "none",
            textAlign: "center",
          })}
          {getRow(`(น.ส.ปฐมา ภากรณ์)`, "100%", {
            paddingVertical: "0px",
            paddingTop: "0px",
            border: "none",
            textAlign: "center",
          })}
          {getRow(`กรรมการบริษัท`, "100%", {
            paddingVertical: "0px",
            marginTop: "0px",
            border: "none",
            textAlign: "center",
          })}
        </View>
        <View style={{ width: "5px" }}></View>
        <View
          style={{
            display: "flex",
            justifyContent: "end",
            alignItems: "end",
            flex: "1",
            verticalAlign: "bottom",
            flexDirection: "column",
            border: "1px solid #c0bcbc",
            paddingVertical: "10px",
          }}
        >
          <View
            style={{
              // backgroundColor: "#f9f9f9",
              marginTop: "70px",
              padding: "0px",
            }}
          >
            {getRow(`......................................`, "100%", {
              border: "none",
              textAlign: "center",
            })}
            {getRow(`(...................)`, "100%", {
              border: "none",
              textAlign: "center",
            })}
            {getRow(`ผู้วางบิล`, "100%", {
              border: "none",
              textAlign: "center",
            })}
          </View>
        </View>
      </View>
    </View>
  );
};

const getHeader = (text, x, style2) => (
  <Text
    style={{
      ...styles.textSmall,
      ...styles.itemHeader,
      ...{
        width: x ?? "0px",
        border: "1px solid black",
        textAlign: "center",
        margin: "-1px",
      },
      ...style2,
    }}
  >
    {text}
  </Text>
);

const getRow = (text, x, style2) => (
  <Text
    style={{
      ...styles.textSmall,
      ...{
        width: x ?? "0px",
        textAlign: "left",
        border: "1px solid black",
        margin: "-1px",
        verticalAlign: "top",
        paddingLeft: "5px",
        paddingVertical: "2px",
      },
      ...style2,
    }}
  >
    {text}
  </Text>
);
